import { render, staticRenderFns } from "./MemberPressSettings.vue?vue&type=template&id=3bc7ec06"
import script from "./MemberPressSettings.vue?vue&type=script&lang=js"
export * from "./MemberPressSettings.vue?vue&type=script&lang=js"
import style0 from "./MemberPressSettings.vue?vue&type=style&index=0&id=3bc7ec06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports